// The answer control for "set the clock" questions (21 Oct 2026, Year 3):
// the clock, with buttons that move its hands. Buttons, not dragging, work
// well on a phone. The time is never printed while the hands are set: reading
// the clock is the skill. Wording approved by the owner on 21 Oct 2026.
import { ClockPictureView } from '../../platform/content/practice-clock';
import {
  joinClockText,
  moveClock,
  splitClockText,
} from '../../platform/content/clockAnswer';

type Props = {
  value: string;
  disabled: boolean;
  onChange: (value: string) => void;
};

const HOUR_BUTTONS: [string, number][] = [
  ['Hour back', -60],
  ['Hour on', 60],
];

const MINUTE_BUTTONS: [string, number][] = [
  ['5 minutes back', -5],
  ['1 minute back', -1],
  ['1 minute on', 1],
  ['5 minutes on', 5],
];

export function SetClockAnswer({ value, disabled, onChange }: Props) {
  const time = splitClockText(value);
  const move = (minutes: number) => {
    onChange(joinClockText(moveClock(time, minutes)));
  };
  return (
    <div className="grid gap-3">
      <ClockPictureView clock={{ type: 'clock', ...time }} />
      <div
        role="group"
        aria-label="Hour hand"
        className="grid grid-cols-2 gap-2"
      >
        {HOUR_BUTTONS.map(([label, minutes]) => (
          <button
            key={label}
            type="button"
            className="dm-btn-secondary min-h-11"
            disabled={disabled}
            onClick={() => {
              move(minutes);
            }}
          >
            {label}
          </button>
        ))}
      </div>
      <div
        role="group"
        aria-label="Minute hand"
        className="grid grid-cols-2 gap-2 sm:grid-cols-4"
      >
        {MINUTE_BUTTONS.map(([label, minutes]) => (
          <button
            key={label}
            type="button"
            className="dm-btn-secondary min-h-11"
            disabled={disabled}
            onClick={() => {
              move(minutes);
            }}
          >
            {label}
          </button>
        ))}
      </div>
      {value !== '' && (
        <button
          type="button"
          disabled={disabled}
          className="dm-link-quiet w-fit"
          onClick={() => {
            onChange('');
          }}
        >
          Start again
        </button>
      )}
      <p className="text-center text-base text-muted">
        Move the hands, then press Submit.
      </p>
    </div>
  );
}
